// NoAutofillInput.jsx — an <input> (or <textarea>, via as="textarea") that the
// browser can't autofill.
//
// Chrome ignores autocomplete="off" on fields it decides are contact/address
// fields, and when you pick one of its suggestions in any field it fills every
// such field in the form from your own saved profile - that's how our own
// address and email ended up on client quotes. Chrome never autofills a
// read-only field, so this stays read-only until the user actually presses,
// taps or tabs into it, then behaves like a normal field. Switching on
// pointerdown (before focus) means phone keyboards still open on the first tap.

import React, { useState } from "react";

export default function NoAutofillInput({ as: Tag = "input", onFocus, onPointerDown, ...props }) {
  const [editable, setEditable] = useState(false);
  return (
    <Tag
      {...props}
      autoComplete="off"
      data-lpignore="true"
      data-1p-ignore="true"
      readOnly={!editable}
      onPointerDown={e => { if (!editable) setEditable(true); if (onPointerDown) onPointerDown(e); }}
      onFocus={e => { if (!editable) setEditable(true); if (onFocus) onFocus(e); }}
    />
  );
}
